<template>
    <div>
        <DsCard>
            <DsCardBody>
                <div class="ktv-card-header">
                    <div>
                        <div data-qa="ktv-card-title" class="headline-1">
                            {{ title }}
                        </div>

                        <div
                            v-if="description"
                            data-qa="ktv-card-description"
                            class="headline-5"
                        >
                            <small>{{ description }} </small>
                        </div>
                    </div>

                    <div v-if="isComplete || icon" class="icon-container" data-qa="ktv-card-icon">
                        <DsIcon
                            v-if="showError"
                            color="red"
                            data-qa="ktv-card-icon-error"
                            name="alert-octagon"
                        />

                        <DsIcon
                            v-if="isComplete"
                            color="green"
                            data-qa="ktv-card-icon-complete"
                            :name="icon"
                        />

                        <DsIcon
                            v-if="!showError && !isComplete"
                            color="gray"
                            data-qa="ktv-card-icon-no-complete"
                            :name="icon"
                        />
                    </div>
                </div>

                <div data-qa="content">
                    <slot name="content" />
                </div>
            </DsCardBody>
        </DsCard>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
        isComplete: Boolean,
        showError: Boolean,
    },
};

</script>

<style scoped lang="scss">

.ktv-card-header {
    display: flex;
    justify-content: space-between;
}

.headline-1 {
    color: $color-ink-900;
    font-family: $font-family;
    font-size: $font-size-lg;
    font-weight: $font-weight-regular;
    line-height: $line-height-lg;
}

.headline-5 {
    color: $color-ink-800;
    font-family: $font-family;
    font-size: $font-size-sm;
    font-weight: $font-weight-regular;
    line-height: $line-height-sm;
    margin-top: $spacing-100;
    margin-bottom:$spacing-300;
}

</style>
